import moment from 'moment';

/**
 * this function receives two parameters the hour and the minutes 
 * for return one date with this horary
 * @param  {} hours
 * @param  {} minutes
 */
let returnDate = (hours, minutes) => {
	let date = new Date()
	date.setHours(hours)
	date.setMinutes(minutes);
	return date;
}

let returnHoray = () => {
	const dates = [
		new Date(new Date().setDate(new Date().getDate() + 0)),
		new Date(new Date().setDate(new Date().getDate() + 1)),
		new Date(new Date().setDate(new Date().getDate() + 2)),
		new Date(new Date().setDate(new Date().getDate() + 3)),
		new Date(new Date().setDate(new Date().getDate() + 4)),
		new Date(new Date().setDate(new Date().getDate() + 5)),
		new Date(new Date().setDate(new Date().getDate() + 6)),
	];
	let horary = {};

	dates.forEach(element => {
		let arrayDate = [];
		arrayDate.push(returnDate(Math.floor(Math.random() * 24), Math.floor(Math.random() * 60)));
		arrayDate.push(returnDate(Math.floor(Math.random() * 24), Math.floor(Math.random() * 60)));
		arrayDate.push(returnDate(Math.floor(Math.random() * 24), Math.floor(Math.random() * 60)));
		arrayDate.push(returnDate(Math.floor(Math.random() * 24), Math.floor(Math.random() * 60)));
		arrayDate.push(returnDate(Math.floor(Math.random() * 24), Math.floor(Math.random() * 60)));
		arrayDate.push(returnDate(Math.floor(Math.random() * 24), Math.floor(Math.random() * 60)));
		horary[moment(element).format('YYYY-MM-DD')] = arrayDate;
	});

	return horary;
}

const doctorList = [{
	doctor: {
		name: 'Dr. Ivan Marshall, MD ',
		synthesis: `Lorem ipsum dolor sit amet consectetur adipisicing elit. 
                                    Quisquam voluptatem vitae quasi, corporis reiciendis labore 
                                    aperiam illo unde temporibus perspiciatis`,
		address: '4062 timber wolf trail',
		stars: 5,
		profession: 'Internist',
		image: 'https://randomuser.me/api/portraits/men/30.jpg',
		gender: 1,
		zip: "19083",
	},
	isSponsored: false,
	carriers: [{
		"id": 324,
		"name": "Anthem Blue Cross Blue Shield",
		"rank": 10213.440206576
	}, {
		"id": 550,
		"name": "Anthem Blue Cross",
		"rank": 3450.7950975920003
	}, ],
	horary: returnHoray(),
	firstDay: moment(new Date(new Date().setDate(new Date().getDate() + 0))).format('YYYY-MM-DD'),
	secondDay: moment(new Date(new Date().setDate(new Date().getDate() + 1))).format('YYYY-MM-DD'),
	thirdDay: moment(new Date(new Date().setDate(new Date().getDate() + 2))).format('YYYY-MM-DD'),
	distance: 5,
	timeBeforeOption: true,
	timeAfterOption: true,
	childrenOption: false,
	majorAvailableDate: returnDate(15, 30),
	languages: [{
		id: 1,
		name: 'Español'
	},
	{
		id: 2,
		name: 'English'
	},
	{
		id: 3,
		name: 'Russky'
	}
	],
	procedures: [{
		id: 1,
		name: "General Consultation"
	},
	{
		id: 2,
		name: "General Follow Up"
	},
	{
		id: 3,
		name: "Anke Problems"
	},
	{
		id: 4,
		name: "Annual Check Up"
	},
	{
		id: 5,
		name: "Annual Physical"
	}
	],
	address: [{
		"id": 1,
		"zip": "19401",
		"latitude": "89.56525358",
		"longitude": "-75.6523689",
		"country": "Spain",
		"streetAddress": "Ave. aa % 1 y 3"
	}]

},
{

	doctor: {
		name: 'Dr. Jhon Doe, MD ',
		synthesis: `Lorem ipsum dolor sit amet consectetur adipisicing elit. 
                                    Quisquam voluptatem vitae quasi, corporis reiciendis labore 
                                    aperiam illo unde temporibus perspiciatis`,
		address: 'Location # Number streets,City, State,Country',
		stars: 1,
		profession: 'Internist',
		image: 'https://randomuser.me/api/portraits/men/83.jpg',
		gender: 1,
		zip: "19063",
	},
	carriers: [{
		"id": 550,
		"name": "Anthem Blue Cross",
		"rank": 3450.7950975920003
	}],
	isSponsored: true,
	horary: returnHoray(),
	firstDay: moment(new Date(new Date().setDate(new Date().getDate() + 0))).format('YYYY-MM-DD'),
	secondDay: moment(new Date(new Date().setDate(new Date().getDate() + 1))).format('YYYY-MM-DD'),
	thirdDay: moment(new Date(new Date().setDate(new Date().getDate() + 2))).format('YYYY-MM-DD'),
	distance: 35,
	timeBeforeOption: false,
	timeAfterOption: true,
	childrenOption: true,
	majorAvailableDate: returnDate(22, 30),
	languages: [{
		id: 1,
		name: 'Español'
	},
	{
		id: 2,
		name: 'English'
	}
	],
	procedures: [{
		id: 2,
		name: "General Follow Up"
	},
	{
		id: 3,
		name: "Anke Problems"
	},
	{
		id: 4,
		name: "Annual Check Up"
	}
	],
	"address": [{
		"id": 3,
		"zip": "10400",
		"latitude": "89.56525358",
		"longitude": "-75.6523689",
		"country": "Spain",
		"streetAddress": "Ave. cc % 1 y 3"
	}]

},
{

	doctor: {
		name: 'Dr. Erin Mcdonalid, MD ',
		synthesis: `Lorem ipsum dolor sit amet consectetur adipisicing elit. 
                                    Quisquam voluptatem vitae quasi, corporis reiciendis labore 
                                    aperiam illo unde temporibus perspiciatis`,
		address: '2113 white oak dr',
		stars: 3,
		profession: 'Patology',
		image: 'https://randomuser.me/api/portraits/women/55.jpg',
		gender: 0,
		zip: "19803",
	},
	isSponsored: false,
	horary: returnHoray(),
	firstDay: moment(new Date(new Date().setDate(new Date().getDate() + 0))).format('YYYY-MM-DD'),
	secondDay: moment(new Date(new Date().setDate(new Date().getDate() + 1))).format('YYYY-MM-DD'),
	thirdDay: moment(new Date(new Date().setDate(new Date().getDate() + 2))).format('YYYY-MM-DD'),
	distance: 20,
	carriers: [{
		"id": 300,
		"name": "Aetna",
		"rank": 37636.994317144
	},
	{
		"id": 324,
		"name": "Anthem Blue Cross Blue Shield",
		"rank": 10213.440206576
	},
	{
		"id": 338,
		"name": "EmblemHealth (formerly known as GHI)",
		"rank": 8686.058181978
	}
	],
	timeBeforeOption: false,
	timeAfterOption: false,
	childrenOption: true,
	majorAvailableDate: returnDate(6, 20),
	languages: [{
		id: 2,
		name: 'English'
	},
	{
		id: 3,
		name: 'Russky'
	}
	],
	procedures: [

		{
			id: 2,
			name: "General Follow Up"
		},
		{
			id: 5,
			name: "Annual Physical"
		}
	],
	"address": [{
		"id": 5,
		"zip": "19401",
		"latitude": "89.56525358",
		"longitude": "-75.6523689",
		"country": "Spain",
		"streetAddress": "Ave. rr % 1 y 3"
	}]
}
];


export default doctorList;


// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/stories/mock/doctorList.js